// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-height {\r\n  position: relative;\r\n  height: 100%;\n}\n.el-dialog__body {\r\n  padding-top: 0px;\n}\n.no-tax-price {\r\n  font-size: 17px;\r\n  color: blue;\r\n  font-weight: bold;\n}\n.tax-price {\r\n  font-size: 17px;\r\n  color: green;\r\n  font-weight: bold;\n}\n.accountsPayableManagement-app-container div.el-dialog__body {\r\n  position: relative;\r\n  height: 86%;\n}\r\n", ""]);
// Exports
module.exports = exports;
